module.exports = __webpack_public_path__ + "static/media/02.Krishna Pooja-ink.86b0f98c.jpeg";